export default "__VITE_ASSET__Cd4GMY2S__"